import React from 'react';
import type { Activity } from '../../types/activity';
import type { Density } from '../../types/ui';
import { ChannelBadge } from './ChannelBadge';
import { OutcomeTag } from './OutcomeTag';
import { formatDuration, formatTime, isMeaningful } from '../../utils/timeline';
interface ActivityRowProps {
  activity: Activity;
  selected: boolean;
  density: Density;
  nested?: boolean;
  onSelect: (id: string) => void;
}
export function ActivityRow({
  activity,
  selected,
  density,
  nested = false,
  onSelect
}: ActivityRowProps) {
  const compact = density === 'compact';
  const strong = isMeaningful(activity);
  return <button type="button" onClick={() => onSelect(activity.id)} aria-current={selected ? 'true' : undefined} className={`group relative flex w-full items-start gap-3 pr-3 text-left transition-colors duration-150 ease-emphasis focus-visible:outline focus-visible:outline-2 focus-visible:-outline-offset-2 focus-visible:outline-accent ${compact ? 'py-2' : 'py-3'} ${nested ? 'pl-4' : 'pl-6'} ${selected ? 'bg-surface-raised' : 'hover:bg-surface-muted'}`} data-id="element-37" data-mp="2r622ks7wwzkb">
      {selected && <span className="absolute inset-y-0 left-0 w-[3px] bg-gold" data-id="element-38" data-mp="3cvjhvsj9hr2r" />}

      <time dateTime={activity.at} className={`w-[58px] shrink-0 pt-0.5 text-right text-[12px] tabular-nums ${strong ? 'text-ink-muted' : 'text-ink-subtle'}`} data-id="element-39" data-mp="3qq2efnciy0d5">
        {formatTime(activity.at)}
      </time>

      <ChannelBadge channel={activity.channel} size={compact ? 'sm' : 'md'} tone={activity.channel === 'call' && activity.outcome === 'connected' ? 'positive' : 'plain'} data-id="element-40" data-mp="3vodnhvuzw6ub" />

      <span className="min-w-0 flex-1" data-id="element-41" data-mp="9hfeqzzml5cy">
        <span className={`block truncate text-[13.5px] ${strong ? 'font-semibold text-ink' : 'font-normal text-ink-muted group-hover:text-ink'}`} data-id="element-42" data-mp="2f9ceglyp24rz">
          {activity.title}
        </span>
        {!compact && <span className="mt-0.5 block truncate text-[12.5px] text-ink-subtle" data-id="element-43" data-mp="e9qxq8snf43a">
            {activity.summary}
          </span>}
      </span>

      <span className="flex shrink-0 items-center gap-2.5 pt-0.5" data-id="element-44" data-mp="o4rbpehkbee0">
        {activity.durationSeconds ? <span className="hidden text-[12px] tabular-nums text-ink-subtle sm:inline" data-id="element-45" data-mp="t68bt7s82wtj">
            {formatDuration(activity.durationSeconds)}
          </span> : null}
        <span className="w-[82px] text-right" data-id="element-46" data-mp="124jy4xm238g6">
          <OutcomeTag outcome={activity.outcome} data-id="element-47" data-mp="1238tkvksdwo0" />
        </span>
      </span>
    </button>;
}